import {Component, Input, SimpleChanges} from '@angular/core';
import { CurrencyPipe, DatePipe, NgIf } from "@angular/common";
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule } from "@clr/angular";
import { Orders, StatusButtons } from "../../../../_shared/interfaces";

import * as XLSX from "xlsx";
import { RouterLink } from "@angular/router";
import {AlertService, IAlertType, OrdersStoreService} from "../../../../_shared/services";
import {ClarityIcons, twoWayArrowsIcon} from "@cds/core/icon";

@Component({
  selector: 'app-orders-overview',
  standalone: true,
  imports: [
    NgIf,
    ClrIconModule,
    ClrDatagridModule,
    RouterLink,
    DatePipe,
    CurrencyPipe
  ],
  templateUrl: './orders-overview.component.html',
  styleUrl: './orders-overview.component.sass'
})
export class OrdersOverviewComponent {
  orders: Orders[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;
  statusLabel = 'alert-info';
  statusText = '';

  @Input() status!: string;

  statusButtons: StatusButtons[] = [
    { state: 'open', display: 'Entwurf', label: 'label-light-blue', icon: 'info-circle'},
    { state: 'confirmed', display: 'Bestätigt', label: 'alert-info', icon: 'check-circle'},
    { state: 'running', display: 'In Arbeit', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'storno', display: 'Storniert', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'shipped', display: 'Abgeschickt', label: 'alert-info', icon: 'check-circle'},
    { state: 'invoiced', display: 'Berechnet', label: 'alert-green', icon: 'exclamation-circle'},
    { state: 'done', display: 'Erledigt', label: 'alert-success', icon: 'info-circle'}
  ];

  constructor(
    private orderss: OrdersStoreService,
    private alertDispatcher: AlertService,
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon);
  }

  ngOnInit() {
    this.loadList(this.status);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.loading = true;
    this.loadList(this.status);
  }

  loadList(status: string) {
    this.orderss.getOrders('0',0, 0, status).subscribe({
      next: data => {
        this.orders = data?.object ?? [];
        if (this.orders.length === 0) {
          this.alertDispatcher.show({
            message: 'Keine Orders gefunden.',
            clrAlertType: IAlertType.WARNING
          }, 2000);
        }
      },
      complete: () => {
        this.loading = false;
        this.descSort = ClrDatagridSortOrder.DESC;
      }
    });
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(orderstatus: string, buttons: StatusButtons[]) {
    const idx = buttons.findIndex(el => el.state === orderstatus);
    return idx >= 0 ? idx : 0;
  };

  getCellStatus(orderstatus: string) {
    const statusline = this.findButtonStatus(orderstatus, this.statusButtons);
    return {
      'statusLabel' : this.statusButtons[statusline].label,
      'statusDisplay': this.statusButtons[statusline].display,
      'statusIcon': this.statusButtons[statusline].icon
    };
  }

  findButtonClass(orderstatus: string) {
    return "alert " + this.getCellStatus(orderstatus).statusLabel + " alert-sm";
  }

  exportToExcel(data: any): void {
    // Dokumentation: https://docs.sheetjs.com
    let orders = data;
    orders.map((obj: Orders) => {
      let orders = obj as Partial<Orders>; // Type Assertion
      delete orders['employee_phm'];
      delete orders['order_cid'];
      delete orders['employee_order'];
      delete orders['order_status'];
      delete orders['cond_delivery'];
      delete orders['cond_payment'];
      delete orders['company_delivery'];
      delete orders['person_delivery'];
    })
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(orders);

    const book: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(book, worksheet, 'Orders In Arbeit');

    XLSX.writeFile(book, 'Orders-Übersicht.xlsx');
  }
}
